<script>
  import { link } from 'svelte-routing';
  import { Card, Badge } from 'spaper';
  export let to;
  export let title;
  export let image;
  export let isNew = false;
</script>

<div>
  <a href={to} use:link>
    <Card title={title} image={image} width="90%">
      {#if isNew}
      <Badge type="success" rounded>Nuevo</Badge>
      {/if}
    </Card>
  </a>
</div>

<style>
  a, a:visited {
    color: black;
    text-decoration: none;
    background-image: none;
  }
</style>